// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, number, string } from 'prop-types'
import { Field } from 'redux-form'
import { AutoSuggest } from 'components/Form'
import { assembleQuery, fetchSitesByQuery } from 'helpers/api'
import CustomSuggestionRender from '../CustomSuggestionRender'
import SuggestionDetails from './SuggestionDetails'
import SuggestionsWrapper from './SuggestionsWrapper'

class SiteAutoSuggest extends React.Component {
  static propTypes = {
    defaultContactId: number,
    disabled: bool,
    handleSelection: func.isRequired,
    idRoot: string.isRequired,
    label: string,
    nameRoot: string.isRequired,
    placeholder: string,
    unitType: string.isRequired,
  }

  prepQuery = (siteName, defaultContactId) => {
    const searchArray = [{
      field: 'contactId',
      operator: 'EQ',
      value: defaultContactId,
    }, {
      field: 'siteName',
      operator: 'LIKE',
      value: siteName,
    }]

    return assembleQuery([{
      field: 'search',
      value: searchArray,
    }])
  }

  fetchSuggestions = value => {
    const {
      defaultContactId,
    } = this.props

    if (!defaultContactId) {
      return { entities: [] }
    }
    const query = this.prepQuery(value, defaultContactId)
    return fetchSitesByQuery(query)
  }

  SuggestionComponent = p => (
    <CustomSuggestionRender
      {...p}
      SuggestionDetails={SuggestionDetails}
      unitType={this.props.unitType} />
  )

  render () {
    const {
      disabled,
      handleSelection,
      idRoot,
      label,
      nameRoot,
      placeholder,
    } = this.props

    return (
      <Field
        component={AutoSuggest}
        disabled={disabled}
        fetchSuggestions={this.fetchSuggestions}
        handleSelection={handleSelection}
        id={`${idRoot}siteName`}
        label={label}
        name={`${nameRoot}siteName`}
        optionKey={`siteId`}
        placeholder={placeholder}
        sortKey={`siteName`}
        renderSuggestionsContainer={SuggestionsWrapper}
        SuggestionComponent={this.SuggestionComponent} />
    )
  }
}

export default SiteAutoSuggest
